import ReactMarkdown from "react-markdown";

interface GuideContentProps {
  markdown: string;
}

export function GuideContent({ markdown }: GuideContentProps) {
  return (
    <div className="guide-content max-w-none">
      <ReactMarkdown
        components={{
          h1: ({ children }) => (
            <h1 className="font-display text-xl font-bold tracking-tight text-foreground mb-4">
              {children}
            </h1>
          ),
          h2: ({ children }) => (
            <h2 className="font-display text-lg font-semibold tracking-tight text-foreground mt-6 mb-3">
              {children}
            </h2>
          ),
          h3: ({ children }) => (
            <h3 className="font-display text-base font-semibold text-foreground mt-4 mb-2">
              {children}
            </h3>
          ),
          p: ({ children }) => (
            <p className="text-sm leading-relaxed text-muted mb-3">{children}</p>
          ),
          ul: ({ children }) => (
            <ul className="list-disc pl-5 mb-3 space-y-1 text-sm text-muted">{children}</ul>
          ),
          ol: ({ children }) => (
            <ol className="list-decimal pl-5 mb-3 space-y-1 text-sm text-muted">{children}</ol>
          ),
          li: ({ children }) => <li className="leading-relaxed">{children}</li>,
          strong: ({ children }) => (
            <strong className="font-semibold text-foreground">{children}</strong>
          ),
          a: ({ href, children }) => (
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-accent underline hover:text-accent/80"
            >
              {children}
            </a>
          ),
          code: ({ children }) => (
            <code className="rounded bg-foreground/5 px-1.5 py-0.5 text-xs font-mono text-foreground">
              {children}
            </code>
          ),
          img: ({ src, alt }) => {
            if (!src) return null;
            const isVideo = src.endsWith(".webm") || src.endsWith(".mp4");
            if (isVideo) {
              return (
                <video
                  src={src}
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="my-4 w-full rounded-lg border border-border/30"
                >
                  {alt}
                </video>
              );
            }
            return (
              <img
                src={src}
                alt={alt || ""}
                className="my-4 w-full rounded-lg border border-border/30"
                loading="lazy"
              />
            );
          },
        }}
      >
        {markdown}
      </ReactMarkdown>
    </div>
  );
}
